/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";

import "../../App.css";
import {
    Card, //Col, Row, Button, 
    Form, Select, Checkbox,
    Button, //InputNumber 
} from "antd";
import Jax from "../../Jax/jax.es6.module";
import TableIDs from "../../data/TableIDs";
import { DatePicker } from 'antd';
import moment from "moment";
import PageToolbar from "../../components/PageToolbar";
import LangContext from "../../contextProvider/LangContext";
import ReportTypeButton from "../../components/ReportTypeButton";
import { disabledDatePicker } from "../../utils/utils";
import GenericSelectorPosStorages from "../../components/GenericSelectorPosStorages";
import GenericTable from "../../components/GenericTable";
import GenericModal from "../../components/GenericModal";
import DateTimePicker from "../../components/DateTimePicker";
import TableLineIcons from "../../components/TableLineIcons";

const FormItem = Form.Item;
const Option = Select.Option;

type Props = {
    user: any,
    ui: any,
    uiActions: any,
    baseUrl: string,
    data: Object,
    dataActions: Object,
    ActionQueue: any
};
type State = {};

class PaymentsShva extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            endOpen: false,
            PaymentsShva: {
                RequestedReport: 0,
                LowerSelectionDate: moment().add(-1, "month").format("YYYY-MM-01"),
                UpperSelectionDate: moment().format("YYYY-MM-DD"),
                //LowerSelectionTime: "00:00:00",
                //UpperSelectionTime: "23:59:59",
                PosList: '',
                //ApplyRangeApply: 0,
                //ApplyRangeLower: 0,
                //ApplyRangeUpper: 0,
                SortField: '1',
                reportName: "reports/paymentsShva.pdf"
            },

            modalFilter: false,

            filterActive: false,
            valueSearch: '',
        };
        this.state.type = "pdf";

        this.id = "SHVA_REFERENCES_TABLE";

        if (props.data[this.id] === undefined) {
            props.data[this.id] = { ...props.data.genericData };
        }

        if (props.data[TableIDs.genericSelectorPos] === undefined) {
            props.data[TableIDs.genericSelectorPos] = { ...props.data.genericSelector };
        }

        this.api = {
            get: "get_shva_references_table",
            selector_pos: "list_pos"
        }

        this.props.dataActions.genericSelectorRefreshDataset(
            TableIDs.genericSelectorPos, this.props.user.companyCode, this.props.user.token, this.api.selector_pos);
        //this.setReportParameters("PaymentsShva", { RequestedReport: 0 });


    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.loadData();
        //const list = this.props.data[TableIDs.genericSelectorPos].dataset.map(i => i.code).join(',');
        //this.setReportParameters("PaymentsShva", { mPosList: list });
    }

    setReportParameters(report: string, params: Object) {
        let newState = Jax.mutate(this.state || {}, report, params);
        this.setState(newState);
    }

    generateReport(report: string) {
        let params = Jax.get(this.state || {}, report, null);
        if (params !== null && params.reportName) {
            window.console.log("Generating report...");
            params = this.getFullSelector(params);
            params = { ...params, REPORT_LOCALE: this.getText(101) }
            this.props.ActionQueue.addToQueue({ action: this.props.dataActions.generateReport, args: [this.props.user.companyCode, this.props.user.token, params] });
        }
    }

    getFullSelector = (params) => {
        let fullPosList = this.props.data[TableIDs.genericSelectorPos].dataset.map((obj) => obj['code']).join(',');
        //  let fullStoragesList = this.props.data[TableIDs.genericSelectorStorages].dataset.map((obj) => obj['code']).join(',');
        if (params.PosList === '') params = { ...params, PosList: fullPosList }
        //  if (params.StorageListIssue === '') params = { ...params, StorageListIssue: fullStoragesList }
        return params;
    }

    componentDidUpdate(prevProps) {
        document.title = "Cash On Tab - " + this.getText(10193);
        let posList = this.props.data[TableIDs.genericSelectorPos];
        //   let storagesList = this.props.data[TableIDs.genericSelectorStorages];

        if (
            posList && posList.dataset[0]
            //  &&
            //   storagesList && storagesList.dataset[0]
            && !this.state.loading
        ) {
            this.setState({ loading: true })
        }

        if (prevProps.ui.favoriteParams !== this.props.ui.favoriteParams) {
            this.setReportParameters("PaymentsShva", this.props.ui.favoriteParams)
        }

    }

    loadData() {
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.genericSelectorRefreshDataset,
            args: [TableIDs.genericSelectorPos, this.props.user.companyCode, this.props.user.token, this.api.selector_pos]
        });
    }
    disabledStartDate = (FromDate) => {
        const ToDate = this.state.PaymentsShva.LowerSelectionDate;
        if (!FromDate || !ToDate) {
            return false;
        }
        return FromDate.valueOf() > ToDate.valueOf();
    }

    disabledEndDate = (ToDate) => {
        const FromDate = this.state.PaymentsShva.UpperSelectionDate;
        if (!ToDate || !FromDate) {
            return false;
        }
        return ToDate.valueOf() <= FromDate.valueOf();
    }

    onChange = (field, value) => {
        this.setReportParameters("PaymentsShva", { [field]: value })
    }
    /*
        onChange = (field, value, field2, value2) => {
            console.log("f ",field ,"v ", value);
            this.setReportParameters("PaymentsShva", { [field]: value, [field2]: value2 })
        }*/

    onStartChange = (value) => {
        //let arr = (value ? value.format("YYYY-MM-DD#hh:mm:ss") : '').split('#');;
        //console.log("start date ", arr);
        //this.onChange('LowerSelectionDate', arr[0], 'LowerSelectionTime', arr[1]);
        this.onChange('LowerSelectionDate', value ? value.format("YYYY-MM-DD") : null);
        //this.onChange('LowerSelectionTime', value ? value.format("hh:mm:ss") : null);
        // this.onChange('LowerSelectionDate', value ? value.format("D/M/YY") : null);
        // this.onChange('LowerSelectionTime', value ? value.format("HH:mm") : null);
    }

    onEndChange = (value) => {
        //let arr = (value ? value.format("YYYY-MM-DD#hh:mm:ss") : '').split('#');;
        //console.log("end date ", arr);
        //this.onChange('UpperSelectionDate', arr[0], 'UpperSelectionTime', arr[1]);
        this.onChange('UpperSelectionDate', value ? value.format("YYYY-MM-DD") : null);
        //this.onChange('UpperSelectionTime', value ? value.format("hh:mm:ss") : null);
        // this.onChange('UpperSelectionDate', value ? value.format("D/M/YY") : null);
        // this.onChange('UpperSelectionTime', value ? value.format("HH:mm") : null);
    }
    /*
    handleStartOpenChange = (open) => {
        if (!open) {
            this.setState({ endOpen: true });
        }
    }

    handleEndOpenChange = (open) => {
        this.setState({ endOpen: open });
    }*/

    createCheckBox = (field, data) => {
        return (
            <Checkbox
                style={{ display: 'inline' }}
                onChange={(e) => {
                    if (e.target.checked)
                        this.setReportParameters("PaymentsShva", { [field]: data });
                    else
                        this.setReportParameters("PaymentsShva", { [field]: '' });
                }} />);
    }

    filterOk = () => {
        const { LowerSelectionDate, UpperSelectionDate, PosList } = this.state.PaymentsShva;

        this.setState({ modalFilter: false, filterActive: true }, () => {
            let fullPosList = this.props.data[TableIDs.genericSelectorPos].dataset.map(x => x.code).join(",")

            this.props.dataActions.genericDataSetFilter(
                this.id, this.props.user.companyCode, this.props.user.token, { LowerSelectionDate, UpperSelectionDate, PosList: PosList ? PosList : fullPosList }, this.api.get);
        })
    }

    clearFilter = () => {
        this.setState({
            PaymentsShva: {
                ...this.state.PaymentsShva,
                LowerSelectionDate: null,
                UpperSelectionDate: null,
                PosList: '',
            },
            filterActive: false,
            valueSearch: '',
        }, () => {
            let fullPosList = this.props.data[TableIDs.genericSelectorPos].dataset.map(x => x.code).join(",")
            this.props.dataActions.genericDataSetFilter(
                this.id, this.props.user.companyCode, this.props.user.token, {
                LowerSelectionDate: null,
                UpperSelectionDate: null,
                PosList: fullPosList,
                _words: '',
            }, this.api.get);
        });
    }

    viewReport = (text, record) => {
        return (<>
            <TableLineIcons genericIcons={[{ type: "table", onClick: () => { this.setState({ modalReportView: text }) } }]} />
            <GenericModal
                visible={this.state.modalReportView != null}
                onCancel={() => { this.setState({ modalReportView: null }) }}
                title={`${this.getText(21529)} ${record.eReference}`}
                width={520}>
                {this.state.modalReportView ?
                    this.state.modalReportView.split("ቿ").join(" ").split("\n").map(x => (<p dir="ltr">{x}</p>))
                    : ""}
            </GenericModal>
        </>)
    }


    render() {
        const { PaymentsShva, endOpen } = this.state;
        const { LowerSelectionDate, UpperSelectionDate } = PaymentsShva;

        const divStyle = {
            align: "center",
            dir: "rtl", // dir: 'ltr'
            padding: "2% 2% 2% 2%",

            // display: 'flex',
            // alignItems: 'center',
            // justifyContent: 'center',
            // height: '100%',
            // flexDirection: 'column',
        };

        //const { PaymentsShva } = this.state;
        //const isDocsShownStyle = { display: (PaymentsShva.RequestedReport === 2) ? 'block' : 'none' }
        //const isEndDateShownStyle = { display: (PaymentsShva.RequestedReport === 2) ? 'block' : 'none' }

        // let listPos = Jax.get(this.props.data, TableIDs.genericSelectorPos + ".dataset", []).map((obj, index) => {
        //     return (<Option key={obj['code']} value={obj['code']} valuefilter={obj['name']}>{obj['code'] + '-' + obj['name']}</Option>)
        // });

        //this.setReportParameters("PaymentsShva", {
        //    mPosList: this.props.data[TableIDs.genericSelectorPos].dataset.map(i => i.code).join(',')
        //});

        let mobile = window.innerWidth > 600 ? false : true;

        const gt = this.getText
        const render = t => t
        const sorter = true

        const fromDatePicker = (<FormItem label={this.getText(12212)}>
            <DateTimePicker
                format="DD/MM/YYYY"
                value={LowerSelectionDate}
                onChange={e => { this.onChange("LowerSelectionDate", e) }}
                placeholder={this.getText(12221)}
                minDate={UpperSelectionDate ? moment(UpperSelectionDate).add(-370, "days").format("YYYY-MM-DD") : null}
                maxDate={UpperSelectionDate}
            />
        </FormItem>)

        const toDatePicker = (<FormItem label={this.getText(12213)}>
            <DateTimePicker
                format="DD/MM/YYYY"
                value={UpperSelectionDate}
                onChange={e => { this.onChange("UpperSelectionDate", e) }}
                placeholder={this.getText(12222)}
                minDate={LowerSelectionDate}
                maxDate={LowerSelectionDate ? moment(LowerSelectionDate).add(370, "days").format("YYYY-MM-DD") : null}
            />
        </FormItem>)

        const posSelector = (<FormItem label={this.getText(12214)}>
            <GenericSelectorPosStorages {...this.props} multi
                onChange={(value) => this.setReportParameters("PaymentsShva", { PosList: value.join(',') })}
                value={(this.state.PaymentsShva.PosList === '') ? [] : this.state.PaymentsShva.PosList.split(',')}
            />
        </FormItem>)



        return (
            <div style={divStyle}>
                <GenericTable
                    {...this.props}
                    id={this.id}
                    getApi={this.api.get}
                    columns={[
                        { title: gt(21522), key: "eTimestamp", dataIndex: "eTimestamp", width: "7%", sorter, render: t => (<div dir="ltr">{moment(t).format("DD/MM/YYYY HH:mm")}</div>) },
                        { title: gt(21523), key: "eReference", dataIndex: "eReference", width: "14%", sorter, render },
                        { title: gt(21524), key: "ePosID", dataIndex: "ePosID", width: "14%", sorter, render: (t, r) => t + " - " + r.ePosName },
                        { title: gt(21525), key: "eTransactionCount", dataIndex: "eTransactionCount", width: "7%", sorter, render },
                        { title: gt(21526), key: "eCreditSum", dataIndex: "eCreditSum", width: "11%", sorter, render },
                        { title: gt(21527), key: "eDebitSum", dataIndex: "eDebitSum", width: "9%", sorter, render },
                        { title: gt(21528), key: "eReport", dataIndex: "eReport", width: "5%", render: this.viewReport },
                    ]}
                    title={gt(12211)}
                    actionButtons={[{
                        buttonType: 'filter',
                        buttonFunction: () => { this.setState({ modalFilter: true }) }
                    }, {
                        buttonDisabled: !this.state.filterActive,
                        buttonType: 'clear',
                        buttonFunction: this.clearFilter,
                    }, {
                        buttonType: 'print',
                        buttonFunction: () => { this.setState({ modalReport: true }) }
                    }]}
                    filters={this.state.PaymentsShva}
                />

                <GenericModal
                    visible={this.state.modalFilter}
                    onCancel={() => { this.setState({ modalFilter: false }) }}
                    title={gt(21530)}
                    width={500}
                    footer={[
                        <Button key="Cancel" onClick={() => { this.setState({ modalFilter: false }) }}>{gt(16926)}</Button>,
                        <Button key="Clear" onClick={this.clearFilter}>{gt(16927)}</Button>,
                        <Button key="Filter" type={"primary"} onClick={this.filterOk}>{gt(16928)}</Button>,
                    ]}
                >
                    {fromDatePicker}
                    {toDatePicker}
                    {posSelector}
                </GenericModal>

                <GenericModal
                    visible={this.state.modalReport}
                    onCancel={() => { this.setState({ modalReport: false }) }}
                    title={gt(21531)}
                    width={1000}>
                    <Form className="data-entry-form" layout='horizontal' //layout='vertical' //'horizontal' // inline  |'vertical'|'inline'
                        style={{ columnWidth: 'auto', columnCount: mobile ? '1' : '2', paddingTop: mobile ? 50 : 0 }}
                        onSubmit={this.handleSaveChanges}
                    >
                        {fromDatePicker}
                        {toDatePicker}
                        {posSelector}


                        <ReportTypeButton
                            {...this.props}
                            params={this.state.PaymentsShva}
                            posField={'PosList'}
                            datesToFavorites={[
                                { field: 'LowerSelectionDate', label: this.getText(12212) },
                                { field: 'UpperSelectionDate', label: this.getText(12213) },
                            ]}
                            favoriteSave
                        />


                        {/* <FormItem key={"reportName"} label={this.getText(12216)}>
                            <Select style={{ width: 250 }}
                                //size={"large"}
                                className={"reports/PaymentsShva.pdf"}
                                defaultValue={"pdf"}
                                //combobox={null}
                                //defaultValue={"reports/PaymentsShva.pdf"}
                                onChange={(value) => {
                                    //const type = this.state.PaymentsShva.RequestedReport;
                                    //console.log(type);
                                    //const str = (type === 0) ? '' : type.toString();
                                    //console.log(value,str);
                                    //this.setReportParameters("PaymentsShva", { reportName: "reports/PaymentsShva" + str + ".pdf"})}
                                    //this.setState({ ...this.state, type: value });
                                    this.setReportParameters("PaymentsShva",
                                        {
                                            reportName: "reports/paymentsShva." + value,
                                            type: value
                                        });

                                }}
                            >
                                <Option key={"pdf"}>{this.getText(12217)}</Option>
                                <Option key={"xls"}>{this.getText(12218)}</Option>
                                <Option key={"docx"}>{this.getText(12219)}</Option>
                            </Select>
                        </FormItem>
                        <Button type={"primary"} onClick={() => {
                            //const type = this.state.PaymentsShva.RequestedReport;
                            this.generateReport.apply(this, ["PaymentsShva"])
                        }}>{this.getText(12220)}</Button> */}
                    </Form>
                </GenericModal>
            </div>
        );
    }
}
export default PaymentsShva;